import React, { createContext, ReactNode, useContext, useMemo, useReducer } from 'react';

import { createInitialMockState, SortingBatchMockState } from '../mock/mockState';
import { SortingBatchAction, sortingBatchReducer } from './sortingBatchReducer';

interface SortingBatchContextValue {
    state: SortingBatchMockState;
    dispatch: React.Dispatch<SortingBatchAction>;
}

const SortingBatchContext = createContext<SortingBatchContextValue | null>(null);

interface SortingBatchProviderProps {
    hubPrefix: string;
    /** 测试注入初始状态 */
    initialState?: SortingBatchMockState;
    children: ReactNode;
}

/**
 * 页面级 mock 状态容器：使用方以仓库 id 作为 key 挂载，切换仓库即重建、页面卸载即丢弃。
 * todo batch mock: 后端接入后改为各组件直接 useQuery / useMutation，删除本 Provider。
 */
export const SortingBatchProvider: React.FC<SortingBatchProviderProps> = ({ hubPrefix, initialState, children }) => {
    const [state, dispatch] = useReducer(
        sortingBatchReducer,
        undefined,
        () => initialState || createInitialMockState(hubPrefix, Date.now()),
    );
    const value = useMemo(() => ({ state, dispatch }), [state]);
    return <SortingBatchContext.Provider value={value}>{children}</SortingBatchContext.Provider>;
};

export const useSortingBatchStore = (): SortingBatchContextValue => {
    const ctx = useContext(SortingBatchContext);
    if (!ctx) throw new Error('useSortingBatchStore must be used within SortingBatchProvider');
    return ctx;
};
